import React, { useEffect, useState } from 'react';
import "./SpecialistFormPositions.scss"

import Dropdown from '../../../UI/Dropdown/Dropdown'
import { useSelector } from 'react-redux';

const SpecialistFormPositions = ({ selectHandler = null, selectedPosition = null, errorMessage = '' }) => {
    const positions = useSelector(state => state.specialists.positions)
    const [defaultPosition, setDefaultPosition] = useState(null);

    useEffect(() => {
        if (Array.isArray(selectedPosition) && positions) {
            const selectedPositions = positions.filter((el) => selectedPosition.includes(el.id))
            setDefaultPosition(selectedPositions)
        } else if (selectedPosition && positions) {
            const position = positions.find((el) => Number(el.id) === Number(selectedPosition))            
            if (position) setDefaultPosition(position)
        }
    }, [selectedPosition, positions])    

    return (
        <div className="specialist-form-positions">
            {
                (selectedPosition && defaultPosition || !selectedPosition) &&
                <Dropdown
                    optionsList={positions}
                    optionSelected={defaultPosition}
                    type='positions'
                    label='Роль специалиста'
                    isMultiple={true}
                    selectedHandler={selectHandler}
                    />
            }
            {errorMessage !== '' &&
                <div className="specialist-form-positions__error">
                    {errorMessage}
                </div>
            }
        </div>
    );
};

export default SpecialistFormPositions;
